import React from 'react';
import MenuTop from '../../components/Menu/MenuTop';
import Footer from '../../components/Footer';
import { Container } from './styles';




const Main: React.FC = ({ children }) => {
  return (
    <Container>
      <MenuTop />
      <section>
         {children}
      </section>
       <Footer />
    </Container>
  )
}

export default Main;